import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ITableColumnHeader } from 'src/app/models/table-column-header';
import { StorageService } from 'src/app/providers/storage.service';
import { SM_CONSTANTS } from 'src/app/shared/constants/sm-constants';

@Component({
  selector: 'sm-all-employee-info',
  templateUrl: './all-employee-info.component.html',
  styleUrls: ['./all-employee-info.component.scss']
})
export class AllEmployeeInfoComponent implements OnInit {
  @ViewChild('dateTemplate', { static: true })
  dateTemplateRef!: TemplateRef<HTMLElement>;
  tableColumns: ITableColumnHeader[] = [];
  employeeInfoList: any[] = [];

  constructor(private _storageService: StorageService) { }

  ngOnInit(): void {
    this.tableColumns = [
      {
        columnName: 'name',
        columnProperty: 'userName'
      },
      {
        columnName: 'address',
        columnProperty: 'address'
      },
      {
        columnName: 'mobile',
        columnProperty: 'userPhone'
      },
      {
        columnName: 'Pack name',
        columnProperty: 'planName'
      },
      {
        columnName: 'subscription start',
        columnProperty: 'fromDate',
        columnTemplate: this.dateTemplateRef
      },
      {
        columnName: 'subscription end',
        columnProperty: 'toDate',
        columnTemplate: this.dateTemplateRef
      }
    ];

    const storedSubscriptionData = JSON.parse(this._storageService.getValueFromAppStorage(SM_CONSTANTS.USER_SUBSCRIPTION_DATA));
    // console.log(storedSubscriptionData);
    this.employeeInfoList = storedSubscriptionData.userSubsInfo ?  storedSubscriptionData.userSubsInfo  : []
    // this.employeeInfoList = storedSubscriptionData.userSubsInfo;
  }

}
